import React from 'react';
import { Table, TableProps, Grid } from 'antd';

interface ResponsiveTableProps<T> extends TableProps<T> {
    mobileColumns?: TableProps<T>['columns'];
}

export function ResponsiveTable<T extends object>({ 
    columns, 
    mobileColumns,
    scroll,
    ...props 
}: ResponsiveTableProps<T>) {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
    
    const responsiveColumns = isMobile && mobileColumns ? mobileColumns : columns;
    
    const responsiveScroll = isMobile 
        ? { x: 'max-content', ...scroll }
        : scroll;
    
    return (
        <div style={{ 
            width: '100%',
            overflowX: isMobile ? 'auto' : 'visible',
            WebkitOverflowScrolling: 'touch',
        }}>
            <Table<T>
                {...props}
                columns={responsiveColumns}
                scroll={responsiveScroll}
                pagination={isMobile ? {
                    ...props.pagination,
                    size: 'small',
                    showSizeChanger: false,
                    showTotal: undefined,
                } : props.pagination}
            />
        </div>
    );
}